import { motion } from "framer-motion";
import { PROCESS } from "@/constants/testIds";

const STEPS = [
  {
    n: "01",
    title: "Listen & Frame",
    body: "We start by understanding the business, not the brief. Two weeks of research, interviews, and hard questions.",
  },
  {
    n: "02",
    title: "Sketch & Prove",
    body: "Rapid prototypes over polished decks. We prove the risky ideas first, in real code and real interfaces.",
  },
  {
    n: "03",
    title: "Build & Ship",
    body: "Weekly demos, senior craftspeople, one accountable team. No hand-offs, no phantom project managers.",
  },
  {
    n: "04",
    title: "Refine & Scale",
    body: "Post-launch care: analytics, iteration, and infrastructure hardening as your product finds its shape.",
  },
];

export const Process = () => {
  return (
    <section
      data-testid={PROCESS.section}
      className="relative py-28 md:py-40 border-y border-white/[0.05]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-24 max-w-2xl"
        >
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-emerald-300/80 mb-5">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400" />
            How we work
          </div>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.98]">
            A process, not a <br />
            <span className="italic font-normal text-emerald-300">production line.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative pt-8"
            >
              <div className="absolute top-0 left-0 right-0 h-px bg-white/10">
                <motion.div
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, delay: 0.2 + i * 0.08 }}
                  className="h-px bg-emerald-400/70 origin-left"
                />
              </div>
              <span className="block text-emerald-300/80 font-display text-sm mb-6">{s.n}</span>
              <h3 className="font-display font-bold text-white text-2xl md:text-3xl mb-4 tracking-tight">
                {s.title}
              </h3>
              <p className="text-white/60 text-sm md:text-[15px] leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
